import React from 'react';
import PropTypes from 'prop-types';

import { ContentZone, ContentZonesService } from '@sm360/widget-commons-core-services';

const czGroupName = 'widget.login.popup';

class ModalHeader extends React.PureComponent {
    render() {
        let imgTag = '';
        let textTag = '';
        const imageUrl =
            ContentZonesService.getContentZone(czGroupName, 'header') &&
            ContentZonesService.getContentZone(czGroupName, 'header').getValue();

        if (this.props.showImage && imageUrl) {
            imgTag = <img src={imageUrl} alt={this.props.titleContentZone} />;
        }

        if (this.props.showText) {
            textTag = <div className="sr-subtitle-2 is-centered sub-text">{this.props.textContentZone}</div>;
        }

        return (
            <div className="ModalHeader">
                <div className="header-image">
                    {imgTag}
                    {textTag}
                    <div className="sr-subtitle-1 is-centered main-text">{this.props.titleContentZone}</div>
                </div>
            </div>
        );
    }
}

ModalHeader.propTypes = {
    titleContentZone: PropTypes.instanceOf(ContentZone).isRequired,
    textContentZone: PropTypes.instanceOf(ContentZone).isRequired,
    showImage: PropTypes.bool.isRequired,
    showText: PropTypes.bool.isRequired,
};

ModalHeader.displayName = 'ModalHeader';

export default ModalHeader;
